import Headroom from '../../vendor/headroom';

let headroom;

export default () => {
  if (headroom) {
    headroom.destroy();
  }

  const headroomElement = document.querySelector('[data-headroom]');
  let offset = 0;
  let type = headroomElement.getAttribute('data-headroom');

  if (window.theme.breakpoints.current === 'mobile' || window.theme.breakpoints.current === 'tablet') {
    type = headroomElement.getAttribute('data-headroom-mobile');
  }

  switch (type) {
    case 'preheader':
      offset = document.querySelector('[data-pre-header]').offsetHeight;
      break;
    case 'header':
      offset = document.querySelector('[data-header]').offsetHeight;
      break;
    case 'both':
      offset = headroomElement.offsetHeight;
      break;
  }

  if (offset > 0) {
    headroom = new Headroom(headroomElement, {
      offset,
    });
    headroom.init();
  }
};
